import { FormField } from './field';
import { FieldControl } from '@signature-it/ngx-generic/enums';

export class BarCode extends FormField {
    controlType = FieldControl.BARCODE;
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] ? options['type'].toLowerCase(): 'text';
    }
}
